var IntelGatherForm;
(function (IntelGatherForm) {
    var subjectType = "";
    var subjectID = 0;
    var subjectName = "";
    var contacts = [];
    var teamContactsUrl = "";
    function Init() {
        $(document).ready(function () {
            $('#intel-gather-form').on('show.bs.modal', function () {
                //reset fields
                $('#intel-gather-form input[name="message-type"]:checked').prop('checked', false);
                $('#intel-gather-form input[name="follow-up-select"]:checked').prop('checked', false);
                $('#intel-gather-form .follow-up-group').hide();
                subjectType = $('#intel-gather-form').find('#subject-type').val();
                subjectID = $('#intel-gather-form').find('#subject-id').val();
                subjectName = $('#intel-gather-form').find('#subject-name').val();
                teamContactsUrl = "/Manage/TeamMembers/GetOutletContacts";
                var subjectText;
                switch (subjectType) {
                    case "Service":
                        subjectText = "[This Service] ".concat(subjectName);
                        break;
                    case "Organisation":
                        subjectText = "[This Organisation] ".concat(subjectName);
                        break;
                    case "Outlet":
                        subjectText = "[This Location] ".concat(subjectName);
                        break;
                    case "Event":
                        subjectText = "[This Event] ".concat(subjectName);
                        teamContactsUrl = "/Account/GetOutletContacts";
                        break;
                    case "Profile":
                        subjectText = subjectName;
                        break;
                }
                $('#subject-text').text(subjectText);
                //TODO: reset fields and flags
                GetTeamMembers($('#intel-gather-form #user-outlet-id').val());
                $('#intel-gather-form').find('#importance-low').prop('checked', true);
                $('#intel-gather-form').find('#risk-low').prop('checked', true);
                $('#intel-gather-form').find('#follow-up-select-no').prop('checked', true);
                $('#intel-gather-form').find('#key-outcome-select').val();
                $('#intel-gather-form').find('#intel-gather-form-message').val();
            });
            $('#btn-intel-gather-form-submit').on('click touchend', function (e) {
                e.preventDefault();
                var flags;
                {
                    var list = [];
                    function GetStringIfSelected($e) {
                        if ($e.prop('checked')) {
                            list.push($e.val());
                        }
                    }
                    GetStringIfSelected($('#intel-flag-phone'));
                    GetStringIfSelected($('#intel-flag-user'));
                    GetStringIfSelected($('#intel-flag-email'));
                    GetStringIfSelected($('#intel-flag-important'));
                    GetStringIfSelected($('#intel-flag-favourite'));
                    flags = list.join(',');
                }
                var followUp = $('#intel-gather-form #follow-up-select-yes').prop('checked');
                var followUpDate = null;
                if (followUp) {
                    followUpDate = $('#follow-up-date').val();
                }
                var outcomeSelect = $('#key-outcome-select').val();
                var outcomes = "";
                if (outcomeSelect && outcomeSelect.length > 0) {
                    outcomes = outcomeSelect.join(', ');
                }
                // get latest data
                subjectType = $('#intel-gather-form').find('#subject-type').val();
                subjectID = $('#intel-gather-form').find('#subject-id').val();
                subjectName = $('#intel-gather-form').find('#subject-name').val();
                var message = {
                    OutletServiceId: -1,
                    Comment: $('#intel-gather-form-message').val(),
                    SubjectType: subjectType,
                    SubjectID: subjectID,
                    InsightType: $('#intel-gather-form input[name="message-type"]:checked').val(),
                    Importance: $('#intel-gather-form input[name="importance-select"]:checked').val(),
                    Risk: $('#intel-gather-form input[name="risk-select"]:checked').val(),
                    FollowUp: followUp,
                    AssignedProfileID: $('#follow-up-assignee-select').val(),
                    AssignedDate: followUpDate,
                    CommentFlags: flags,
                    Outcome: outcomes
                };
                var formValid = document.querySelector('#intel-gather-form form');
                if (formValid && formValid.reportValidity()) {
                    $.ajax({
                        url: "".concat(window.AppSettings.ApiUrl, "/api/v1/organisationcomments/add"),
                        method: 'POST',
                        data: JSON.stringify(message),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function (res) {
                            if (res && res.length > 0) {
                                res.forEach(function (response) {
                                    if (response.Success) {
                                        $.notify({
                                            title: '<strong>Success!</strong>',
                                            message: "Your message has been submitted",
                                            icon: "fa-solid fa-circle-check"
                                        }, {
                                            type: 'success',
                                            placement: {
                                                from: "top",
                                                align: "right"
                                            },
                                            delay: 4000,
                                            timer: 500,
                                        });
                                        $('#btn-intel-gather-form-submit').trigger('geographySubmit', ['success']);
                                    }
                                    else {
                                        $.notify({
                                            title: '<strong>Error!</strong>',
                                            message: response.Message,
                                            icon: "fa-solid fa-triangle-exclamation"
                                        }, {
                                            type: 'danger',
                                            placement: {
                                                from: "top",
                                                align: "right"
                                            },
                                            delay: 4000,
                                            timer: 500,
                                        });
                                    }
                                });
                            }
                            else {
                                $.notify({
                                    title: '<strong>Error!</strong>',
                                    message: "An error has occurred",
                                    icon: "fa-solid fa-triangle-exclamation"
                                }, {
                                    type: 'danger',
                                    placement: {
                                        from: "top",
                                        align: "right"
                                    },
                                    delay: 4000,
                                    timer: 500,
                                });
                            }
                        },
                        error: function () {
                            $.notify({
                                title: '<strong>Error!</strong>',
                                message: "An error has occurred",
                                icon: "fa-solid fa-triangle-exclamation"
                            }, {
                                type: 'danger',
                                placement: {
                                    from: "top",
                                    align: "right"
                                },
                                delay: 4000,
                                timer: 500,
                            });
                        },
                        complete: function () {
                            $('#intel-gather-form').modal('hide');
                        }
                    });
                }
            });
            $('#btn-intel-gather-form-submit-edit-message').off('click touchend').on('click touchend', function (e) {
                var _this = this;
                e.preventDefault();
                $(this).prop('disabled', true);
                var message = {
                    CommentID: $('#intel-gather-form').find('#comment-id').val(),
                    OutletServiceId: -1,
                    Comment: $('#intel-gather-form-message').val(),
                    //SubjectType: subjectType,
                    SubjectID: $('#intel-gather-form').find('#subject-id').val(),
                    //InsightType: $('#intel-gather-form input[name="message-type"]:checked').val(),
                    //FollowUp: followUp,
                    //AssignedProfileID: $('#follow-up-assignee-select').val(),
                    //AssignedDate: followUpDate,
                    //CommentFlags: flags,
                    //Outcome: $('#key-outcome-select').val()
                };
                var formValid = document.querySelector('#intel-gather-form form');
                if (formValid && formValid.reportValidity()) {
                    $.ajax({
                        url: "".concat(window.AppSettings.ApiUrl, "/api/v1/organisationcomments/edit"),
                        method: 'POST',
                        data: JSON.stringify(message),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function (res) {
                            if (res && res.length > 0) {
                                res.forEach(function (response) {
                                    if (response.Success) {
                                        if ($('#comments-table').length) {
                                            $('#comments-table').DataTable().ajax.reload();
                                            $.notify({
                                                title: '<strong>Success!</strong>',
                                                message: "The comment has been updated. The table is fetching new data.",
                                                icon: "fa-solid fa-circle-check"
                                            }, {
                                                type: 'success',
                                                placement: {
                                                    from: "top",
                                                    align: "right"
                                                },
                                                delay: 4000,
                                                timer: 500,
                                            });
                                        }
                                    }
                                    else {
                                        $.notify({
                                            title: '<strong>Error!</strong>',
                                            message: response.Message,
                                            icon: "fa-solid fa-triangle-exclamation"
                                        }, {
                                            type: 'danger',
                                            placement: {
                                                from: "top",
                                                align: "right"
                                            },
                                            delay: 4000,
                                            timer: 500,
                                        });
                                    }
                                });
                            }
                            else {
                                $.notify({
                                    title: '<strong>Error!</strong>',
                                    message: "An error has occurred",
                                    icon: "fa-solid fa-triangle-exclamation"
                                }, {
                                    type: 'danger',
                                    placement: {
                                        from: "top",
                                        align: "right"
                                    },
                                    delay: 4000,
                                    timer: 500,
                                });
                            }
                        },
                        error: function () {
                            $.notify({
                                title: '<strong>Error!</strong>',
                                message: "An error has occurred",
                                icon: "fa-solid fa-triangle-exclamation"
                            }, {
                                type: 'danger',
                                placement: {
                                    from: "top",
                                    align: "right"
                                },
                                delay: 4000,
                                timer: 500,
                            });
                        },
                        complete: function () {
                            $(_this).prop('disabled', false);
                            $('#intel-gather-form').modal('hide');
                        },
                    });
                }
            });
            $('#key-outcome-select').selectize({
                placeholder: "Type or select outcome...",
                onChange: function (value) {
                    $('#key-outcome-select').parent().find('.selectize-control .items .item').removeClass('active');
                },
                plugins: ["remove_button"],
            });
            SetupMessageType();
            SetupFollowup();
            SetupTags();
        });
        // geography stuff
        // TODO: init this differently than default Init
        if ($('#intel-gather-form').data('form-type') === 'geography-comment') {
            teamContactsUrl = "/Manage/TeamMembers/GetOutletContacts";
            GetTeamMembers($('#intel-gather-form').find('#user-outlet-id').val());
            $('#intel-gather-form').find('#subject-type').val('Geography');
            $('#intel-gather-form select.geography-select.geography-select-dataset').selectize({
                onChange: function (value) {
                    var $regionSelectize = $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize;
                    $regionSelectize.enable();
                    $regionSelectize.clear();
                    $regionSelectize.clearOptions();
                    $regionSelectize.onSearchChange("");
                }
            });
            $('#intel-gather-form select.geography-select.geography-select-region').on('change', function () {
                $('#intel-gather-form').find('#subject-id').val($(this).val());
            });
            $('#intel-gather-form select.geography-select.geography-select-region').selectize({
                create: false,
                valueField: 'OtherGeographyID',
                labelField: 'OtherTitle',
                searchField: 'OtherTitle',
                sortField: 'OtherTitle',
                plugins: ['remove_button'],
                delimiter: '|',
                dropdownParent: "body",
                preload: true,
                selectOnTab: true,
                openOnFocus: true,
                closeAfterSelect: false,
                hideSelected: true,
                placeholder: "Select a geography",
                load: function (query, callback) {
                    $.ajax({
                        url: "/Manage/Download/LoadGeographies",
                        type: 'GET',
                        dataType: 'json',
                        data: {
                            s: query,
                            dataset: $('#intel-gather-form select.geography-select.geography-select-dataset').val()
                        },
                        error: function (data) {
                            callback(data);
                        },
                        beforeSend: function () {
                            $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize.settings.placeholder = "Loading geographies...";
                            $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize.updatePlaceholder();
                            $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize.disable();
                        },
                        success: function (data) {
                            $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize.settings.placeholder = "Select a geography";
                            $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize.updatePlaceholder();
                            $('#intel-gather-form select.geography-select.geography-select-region')[0].selectize.enable();
                            callback(data.Results);
                        },
                    });
                }
            });
        }
    }
    IntelGatherForm.Init = Init;
    function GetTeamMembers(outletid) {
        if (outletid && outletid > 0 && contacts && contacts.length === 0) {
            $.ajax({
                method: 'POST',
                url: teamContactsUrl,
                data: JSON.stringify({ outletId: outletid }),
                contentType: 'application/json',
                beforeSend: function () {
                    $('#follow-up-assignee-select').selectize({
                        create: false,
                        sortField: 'text'
                    });
                    $('#follow-up-assignee-select')[0].selectize.settings.placeholder = "Loading your team members...";
                    $('#follow-up-assignee-select')[0].selectize.updatePlaceholder();
                    $('#follow-up-assignee-select')[0].selectize.disable();
                },
                success: function (response) {
                    if (response && response.Success && response.Data && response.Data.length > 0) {
                        var data = response.Data.map(function (contact) {
                            //const emailParts = contact.Email?.split('@');
                            //var emailStart = "";
                            //var emailAt = "";
                            //if (emailParts && emailParts.length == 2) {
                            //    emailStart = emailParts[0];
                            //    emailAt = emailParts[1];
                            //}
                            return {
                                ProfileID: contact.ProfileID,
                                FullName: contact.FullName,
                                Email: contact.Email,
                                ContactID: contact.ContactID
                            };
                        });
                        // Clear previous options
                        //$('#follow-up-assignee-select').empty();
                        // Initialize or reinitialize Selectize after adding the options
                        //var selectize = $('#follow-up-assignee-select')[0].selectize;
                        //if (selectize) {
                        //    selectize.destroy();
                        //}
                        // Add the new options dynamically
                        data.forEach(function (contact) {
                            $('#follow-up-assignee-select')[0].selectize.addOption({ value: contact.ProfileID, text: contact.FullName + " (" + contact.Email + ")" });
                            //$('#follow-up-assignee-select').append(
                            //    $('<option>', {
                            //        value: contact.ProfileID,
                            //        text: contact.FullName + " (" + contact.Email + ")"
                            //    })
                            //);
                        });
                        // Re-initialize Selectize
                        //$('#follow-up-assignee-select').selectize({
                        //    create: false,
                        //    sortField: 'text'
                        //});
                        //if (data.length > 0) {
                        //    $('#follow-up-assignee-select')[0].selectize.removeOption(-1);
                        //    $('#follow-up-assignee-select')[0].selectize.refreshOptions();
                        //}
                        $('#follow-up-assignee-select')[0].selectize.settings.placeholder = 'Select an assignee from your team';
                        $('#follow-up-assignee-select')[0].selectize.updatePlaceholder();
                        // Enable the select element after loading options
                        $('#follow-up-assignee-select')[0].selectize.enable();
                    }
                },
                error: function (response) { },
                complete: function () { }
            });
        }
    }
    function SetupFollowupDate() {
        $('#intel-gather-form input[name="date"]').daterangepicker({
            singleDatePicker: true,
            showDropdowns: true,
            minYear: parseInt(moment().format('YYYY'), 10),
            minDate: moment(),
            maxYear: parseInt(moment().format('YYYY'), 10) + 2,
            locale: {
                format: 'DD/MM/YYYY'
            }
        }, function (start, end, label) { });
    }
    function SetupMessageType() {
        $('input[name="message-type"]').off('click touchend').on('click touchend', function () { });
    }
    function SetupFollowup() {
        $('input[name="follow-up-select"]').off('click touchend').on('click touchend', function () {
            if ($('input[name="follow-up-select"]:checked').length > 0
                && $('input[name="follow-up-select"]:checked').val() === $(this).val()
                && $(this).val() === '1') {
                $('.follow-up-group').show();
                $('#follow-up-date').prop('required', true);
            }
            else {
                $('.follow-up-group').hide();
                $('#follow-up-date').prop('required', false);
            }
        });
        SetupFollowupDate();
    }
    function SetupTags() {
        function BtnToggleFlag($btn, $input) {
            function EnableTag() {
                $btn.addClass("flag-active");
                $input.prop('checked', true);
            }
            function DisableTag() {
                $btn.removeClass("flag-active");
                $input.prop('checked', false);
            }
            if ($input.prop('checked') === false) {
                EnableTag();
            }
            else {
                DisableTag();
            }
        }
        $('#btn-flag-phone').off('click touchend').on('click touchend', function (e) {
            e.preventDefault();
            BtnToggleFlag($(this), $('#intel-flag-phone'));
        });
        $('#btn-flag-user').off('click touchend').on('click touchend', function (e) {
            e.preventDefault();
            BtnToggleFlag($(this), $('#intel-flag-user'));
        });
        $('#btn-flag-email').off('click touchend').on('click touchend', function (e) {
            e.preventDefault();
            BtnToggleFlag($(this), $('#intel-flag-email'));
        });
        $('#btn-flag-important').off('click touchend').on('click touchend', function (e) {
            e.preventDefault();
            BtnToggleFlag($(this), $('#intel-flag-important'));
        });
        $('#btn-flag-favourite').off('click touchend').on('click touchend', function (e) {
            e.preventDefault();
            BtnToggleFlag($(this), $('#intel-flag-favourite'));
        });
    }
})(IntelGatherForm || (IntelGatherForm = {}));
